const { REACT_APP_API_ENV } = process.env;

const shouldLog =
  REACT_APP_API_ENV === 'dev' || REACT_APP_API_ENV === 'staging';
const logger = {
  error: (...args) => {
    if (shouldLog) {
      console.error(...args);
    }
  },
  log: (...args) => {
    if (shouldLog) {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (shouldLog) {
      console.warn(...args);
    }
  },
  zodError: zodValidator => {
    if (shouldLog) {
      console.error('Zod Validation Error:', zodValidator?.error?.issues);
    }
  },
  catchError: error => {
    if (shouldLog) {
      console.error('Error:', error?.response?.data?.Error);
    }
  },
};

export default logger;
